import { Log } from "@/models/logging/log";
import { getCompositeKey } from "@/services/format/key";
import envSettings from "@/services/system/envSettings";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { delay, http, HttpResponse } from "msw";
import { getStartPageAdministratorLog, getStartPageApplicationLog, getStartPageRevisionsLog } from "../sets/logSet";

const logAdapter = createEntityAdapter({
  selectId: (item: Log) =>
    getCompositeKey({
      a: "logData",
      b: item.msg,
      c: item.clsRequest.requestId,
    }).toString(),
});
let logState = logAdapter.getInitialState();
logState = logAdapter.setMany(logState, [
  getStartPageRevisionsLog,
  getStartPageApplicationLog,
  getStartPageAdministratorLog,
]);

export const infrastructureHandlers = [
  http.get(`${envSettings.UTILS_API_URL}/${envSettings.SERVER_DATETIME_PREF}`, () => {
    return HttpResponse.text("2023-12-27T09:58:27.820Z", { status: 200 });
  }),

  http.post(`${envSettings.LOG_API_URL}/${envSettings.LOG_PREF}`, async () => {
    await delay(150);
    return HttpResponse.json(Object.values({ logs: Object.values(logState.entities) }), { status: 200 });
  }),
];
